import { Suspense } from 'react'
import Field from '../../../../fields'
import EditProfileCard, { CardFields } from '../EditProfileCard'

type EmergencyContactCardProps = {
  fields: Record<string, any>
  formId: string
  accountFieldsOnly?: boolean
  testId?: string
}

const EmergencyContactCard = ({
  fields,
  formId,
  accountFieldsOnly = false,
  testId
}: EmergencyContactCardProps) => (
  <EditProfileCard title="Emergency contact" testId={testId}>
    <Suspense fallback={<div>Loading...</div>}>
      <CardFields>
        <Field
          formId={formId}
          keys={['emergencyContactName.first', 'emergencyContactName.last']}
          label="Emergency contact"
          placeholders={['First name', 'Last name']}
          type="multiText"
          disabled={accountFieldsOnly}
          values={fields}
        />
        <Field
          formId={formId}
          keys="emergencyContactRelation"
          label="Emergency contact relation"
          type="text"
          disabled={accountFieldsOnly}
          values={fields}
        />
        <Field
          className="emergencynumber-field"
          formId={formId}
          keys="emergencyContactNumber"
          label="Emergency contact telephone"
          options={{ phone: true, phoneRegionCode: 'GB' }}
          type="formattedText"
          disabled={accountFieldsOnly}
          readOnly={accountFieldsOnly}
          values={fields}
        />
      </CardFields>
    </Suspense>
  </EditProfileCard>
)

export default EmergencyContactCard
